// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient[data-v-4e27e373]{background-image:url(/images/newsletter-background.jpg);background-position:50%;background-size:cover}.close-icon[data-v-4e27e373]{box-sizing:content-box;cursor:pointer;height:1.25rem;padding:1rem;position:absolute;right:0;top:0;transition-duration:.15s}.close-icon[data-v-4e27e373]:hover{opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
